'use client';

import {useSearchParams} from 'next/navigation';
import {useEffect} from 'react';
import {usePurchaseContext} from './PurchaseProvider';

export const PurchaseInitializer = () => {
	const {
		state: purchaseState,
		setPurchaseStates,
		actions,
		purchasableProducts
	} = usePurchaseContext();
	const params = useSearchParams();
	const purchaseIntentId = params.get('purchaseIntentId');

	const [purchaseIntentSandboxId, purchaseIntentOfferId] = purchaseIntentId
		? decodeURIComponent(purchaseIntentId).split('-')
		: [];

	useEffect(() => {
		setPurchaseStates([
			'inactive',
			'confirmAuth',
			// "compatibility",
			// "entitlement",
			// "eula",
			'checkout',
			'purchaseCompleted'
			// "download",
		]);
	}, []);

	useEffect(() => {
		// if user clicks Buy while logged out, start purchase flow on login
		if (!purchaseIntentSandboxId || !purchaseIntentOfferId) {
			return;
		}

		if (purchaseState === 'inactive' && 'inactive' in actions) {
			const isAutoSurfaceCheckoutAllowed = () => {
				return purchasableProducts.find((p) =>
					p.offerIds.find((offerId) => offerId === purchaseIntentOfferId)
				);
			};

			if (isAutoSurfaceCheckoutAllowed()) {
				console.log('reinitializing...', purchaseIntentId);
				actions.inactive.reinitialize({
					currentStepIndex: 1,
					offerId: purchaseIntentOfferId,
					sandboxId: purchaseIntentSandboxId
				});
			}
		}
	}, [actions, purchaseIntentSandboxId, purchaseIntentOfferId]);

	return null;
};
